(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-image-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('community-image-carousel')) {
    customElements.define(
      'community-image-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.previous = this.querySelector('[data-previous]');
          this.next = this.querySelector('[data-next]');
          if (!this.track) return;

          this.previous?.addEventListener('click', () => this.move(-1));
          this.next?.addEventListener('click', () => this.move(1));

          if (
            this.dataset.autoplay === 'true' &&
            this.dataset.designMode !== 'true' &&
            !window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ) {
            this.prepareLoop();
            this.start();
            this.track.addEventListener('pointerdown', () => this.stop());
            this.track.addEventListener('pointerup', () => this.start());
            this.track.addEventListener('pointercancel', () => this.start());
            this.addEventListener('focusin', () => this.stop());
            this.addEventListener('focusout', () => this.start());
          }
        }

        disconnectedCallback() {
          this.stop();
        }

        move(direction) {
          const slide = this.track.querySelector('.vh-community__slide');
          if (!slide) return;
          const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
          const distance = slide.getBoundingClientRect().width + gap;
          const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;

          if (direction > 0 && atEnd) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
          }
        }

        prepareLoop() {
          if (this.loopPrepared) return;
          const slides = [...this.track.querySelectorAll('.vh-community__slide')];
          if (slides.length < 2) return;
          const firstSlide = slides[0];
          const lastSlide = slides[slides.length - 1];
          const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
          this.originalWidth = lastSlide.offsetLeft + lastSlide.offsetWidth - firstSlide.offsetLeft + gap;

          for (const slide of slides) {
            const clone = slide.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            this.track.append(clone);
          }

          this.loopPrepared = true;
          const pixelsPerSecond = (Number(this.dataset.speed) || 4) * 12;
          this.style.setProperty('--vh-community-loop-distance', `${this.originalWidth}px`);
          this.style.setProperty('--vh-community-loop-duration', `${this.originalWidth / pixelsPerSecond}s`);
          this.classList.add('is-marquee-ready');
        }

        start() {
          if (!this.loopPrepared) return;
          this.track.style.animationPlayState = 'running';
        }

        stop() {
          if (this.track) this.track.style.animationPlayState = 'paused';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-marquee')) {
    customElements.define(
      'announcement-marquee',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track || this.track.children.length === 0) return;
          requestAnimationFrame(() => this.prepare());
          this.addEventListener('pointerenter', () => this.pause());
          this.addEventListener('pointerleave', () => this.play());
          this.addEventListener('focusin', () => this.pause());
          this.addEventListener('focusout', () => this.play());
          this.resizeObserver = new ResizeObserver(() => {
            window.clearTimeout(this.resizeTimer);
            this.resizeTimer = window.setTimeout(() => this.prepare(), 120);
          });
          this.resizeObserver.observe(this);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          window.clearTimeout(this.resizeTimer);
        }

        prepare() {
          this.classList.remove('is-ready');
          this.track.querySelectorAll('[data-announcement-clone]').forEach((clone) => clone.remove());
          const items = [...this.track.children];
          if (items.length === 0) return;
          const first = items[0];
          const last = items[items.length - 1];
          const width = last.offsetLeft + last.offsetWidth - first.offsetLeft;
          if (width <= 0) return;
          do {
            for (const item of items) {
              const clone = item.cloneNode(true);
              clone.setAttribute('data-announcement-clone', '');
              clone.setAttribute('aria-hidden', 'true');
              clone.removeAttribute('data-shopify-editor-block');
              this.track.append(clone);
            }
          } while (this.track.scrollWidth < this.clientWidth + width);
          const speedLevel = Number(this.dataset.speed) || 5;
          const pixelsPerSecond = 20 + speedLevel * 8;
          this.style.setProperty('--announcement-distance', `${width}px`);
          this.style.setProperty('--announcement-duration', `${width / pixelsPerSecond}s`);
          this.classList.add('is-ready');
        }

        pause() {
          this.track.style.animationPlayState = 'paused';
        }

        play() {
          this.track.style.animationPlayState = 'running';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroBannerRotator extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hero-banner-slide]')];
      this.currentIndex = 0;
      this.delay = Math.max(Number(this.dataset.interval) || 5000, 3000);
      this.abortController = new AbortController();

      if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const signal = this.abortController.signal;
      this.addEventListener('mouseenter', () => this.stop(), { signal });
      this.addEventListener('mouseleave', () => this.start(), { signal });
      this.addEventListener('focusin', () => this.stop(), { signal });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      }, { signal });
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.abortController?.abort();
    }

    start() {
      if (this.timer || document.hidden || this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.delay);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = undefined;
    }

    show(index) {
      this.currentIndex = index % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    }
  }

  if (!customElements.get('hero-banner-rotator')) {
    customElements.define('hero-banner-rotator', HeroBannerRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-marquee')) {
    customElements.define(
      'reviews-marquee',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          if (
            this.dataset.autoplay === 'true' &&
            this.dataset.designMode !== 'true' &&
            !window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ) {
            this.prepareLoop();
            this.start();
            this.track.addEventListener('pointerdown', () => this.stop());
            this.track.addEventListener('pointerup', () => this.start());
            this.track.addEventListener('pointercancel', () => this.start());
            this.addEventListener('focusin', () => this.stop());
            this.addEventListener('focusout', () => this.start());
          }
        }

        prepareLoop() {
          if (this.loopPrepared) return;
          const cards = [...this.track.querySelectorAll('.vh-reviews__card')];
          if (cards.length < 2) return;
          const firstCard = cards[0];
          const lastCard = cards[cards.length - 1];
          const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
          const originalWidth = lastCard.offsetLeft + lastCard.offsetWidth - firstCard.offsetLeft + gap;

          for (const card of cards) {
            const clone = card.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            this.track.append(clone);
          }

          const pixelsPerSecond = (Number(this.dataset.speed) || 4) * 12;
          this.style.setProperty('--vh-reviews-loop-distance', `${originalWidth}px`);
          this.style.setProperty('--vh-reviews-loop-duration', `${originalWidth / pixelsPerSecond}s`);
          this.loopPrepared = true;
          this.classList.add('is-marquee-ready');
        }

        start() {
          if (this.loopPrepared) this.track.style.animationPlayState = 'running';
        }

        stop() {
          if (this.track) this.track.style.animationPlayState = 'paused';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabbed-collections')) {
    customElements.define(
      'tabbed-collections',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[data-tab]')];
          this.panels = [...this.querySelectorAll('[data-panel]')];
          this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.tab)));
        }

        select(selected) {
          for (const tab of this.tabs) {
            const active = tab.dataset.tab === selected;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', String(active));
          }

          for (const panel of this.panels) {
            panel.hidden = panel.dataset.panel !== selected;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
